import styles from "./index.module.less";
import classNames from "classnames";

export default function ImageAvatarPlaceholder({ className }) {
  return (
    <div
      className={classNames(className, styles.imageAvatar, styles.placeholder)}
    >
      <div className={styles.selectedBoard}>
        <div className={styles.imgWrapper}>
          <div
            style={{
              width: `80px`,
              height: `80px`,
              border: "1px dashed rgba(30, 32, 35, 0.1)",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
    </div>
  );
}
